var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlistedProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10514 13.8476V11.8031C6.10512 11.2831 6.52907 10.8605 7.05433 10.857H8.97838C9.50615 10.857 9.934 11.2806 9.934 11.8031V11.8031V13.8539C9.93387 14.2954 10.2898 14.6563 10.7357 14.6666H12.0184C13.2971 14.6666 14.3337 13.6404 14.3337 12.3745V12.3745V6.55854C14.3268 6.06053 14.0906 5.59288 13.6923 5.28867L9.30547 1.79018C8.53695 1.18102 7.44446 1.18102 6.67594 1.79018L2.30834 5.29502C1.9085 5.59799 1.67192 6.06642 1.66699 6.56489V12.3745C1.66699 13.6404 2.70358 14.6666 3.98227 14.6666H5.26497C5.72189 14.6666 6.09231 14.2999 6.09231 13.8476V13.8476",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.66699,
    y: 0.666687,
    width: 6.66667,
    height: 6.66667,
    rx: 3.33333,
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 4.46668V3.46667H13.6663V4.46668H10.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlistedProperty);
export default __webpack_public_path__ + "static/media/unlistedProperty.44a26a1d9c5c9d937da39899df8cbbb1.svg";
export { ForwardRef as ReactComponent };